import { URL_PREFIX } from '@/server/constants'

const noticeTypes = {
  TERMS_AND_CONDITIONS: 'Terms and Conditions',
  PRIVACY_POLICY: 'Privacy Policy',
  EXPLICIT_CONSENT: 'Explicit consent',
  MARKETING: 'Marketing',
  HIPAA_AUTHORIZATION: 'HIPAA Authorization',
  CONSUMER_NETWORK: 'Consumer Network Notice',
  NOTICE_OF_PRIVACY_PRACTICES: 'Notice of Privacy Practices',
}

// Replicate what Privacy service has
const noticeTypeToFieldName: { [key: string]: string } = {
  [noticeTypes.TERMS_AND_CONDITIONS]: 'agreedTAndCs',
  [noticeTypes.PRIVACY_POLICY]: 'agreedPrivacyPolicy',
  [noticeTypes.EXPLICIT_CONSENT]: 'agreedExplicitConsent',
  [noticeTypes.MARKETING]: 'agreedMarketing',
  [noticeTypes.HIPAA_AUTHORIZATION]: 'agreedHIPAAAuthorization',
  [noticeTypes.NOTICE_OF_PRIVACY_PRACTICES]: 'agreedNoticeOfPrivacyPractices',
  [noticeTypes.CONSUMER_NETWORK]: 'agreedConsumerNetworkNotice',
}

// Notices we want to hide completely
const blacklistedNoticeTypes = [noticeTypes.HIPAA_AUTHORIZATION]

// Notices we want to show as links
const linksNoticeTypes = [
  noticeTypes.PRIVACY_POLICY,
  noticeTypes.NOTICE_OF_PRIVACY_PRACTICES,
]

const userFieldsToStore = [
  'first_name',
  'last_name',
  'email',
  'phone_country_code',
  'phone_number',
  'id',
  'date_of_birth',
  'registration_code',
  'uuid',
  'address_post_code',
]

const REDEMPTION_TYPE = 'hybrid'

// According to wikipedia, the oldest person ever lived was 122 years old.
// Source: https://en.wikipedia.org/wiki/List_of_the_verified_oldest_people
// So, 125 is a sensible choice.
const MAX_YEARS_FOR_DOB = 125

const PersonTypes = {
  FIRST: 'first',
  SECOND: 'second',
  THIRD: 'third',
  OTHER: 'other',
}

const auth0RedirectUri = `${window.location.origin}/callback`
const authTokenStorageKey = 'authToken'
const idTokenStorageKey = 'idToken'

const redemptionErrorsWhiteList = [
  'membership_code_already_present',
  'membership_code_unavailable',
  'invalid_code',
  'base',
]

const tealiumEligibilityScreenSections = {
  CHECK_INSURANCE: 'identity check insurance',
  ADD_POLICY: 'identity add policy number',
  AMEND_DETAILS: 'identity amend details',
}

const limitExceededStatusCode = 429

export {
  noticeTypeToFieldName,
  userFieldsToStore,
  REDEMPTION_TYPE,
  noticeTypes,
  blacklistedNoticeTypes,
  linksNoticeTypes,
  MAX_YEARS_FOR_DOB,
  PersonTypes,
  auth0RedirectUri,
  authTokenStorageKey,
  URL_PREFIX,
  redemptionErrorsWhiteList,
  tealiumEligibilityScreenSections,
  limitExceededStatusCode,
  idTokenStorageKey,
}
